<template>
  <div class="testimonials" :style="{height: `${height}px`}">
    <div class="u-overflow-hidden u-full-height u-relative">

      <div 
        v-for="(testimonial, index) in data"
        class="testimonial u-overflow-hidden"
        :class="index < currentIndex ? 'is-prev' : index > currentIndex ? 'is-next' : 'is-current'"
        ref="testimonials">

        <testimonial-card :data="testimonial">
          <div class="u-w1of10 u-marg-l-1of10 u-w8of10--xs u-flex u-middle">
            <div :class="{'u-row u-center': $device.isTablet}">
              <div class="u-right u-w2of10--sm u-marg-r-1of10--sm">
                <img class="testimonial__arrow u-cursor-pointer u-inline-block u-marg-b-md u-marg-r-0--xs u-w5of10 u-w10of10--sm" src="/images/slider--left.png" alt="left icon" @click="onPrev"/>
              </div>
              <div class="u-right u-w2of10--sm">
                <img class="testimonial__arrow u-cursor-pointer u-inline-block u-marg-b-md u-marg-l-0--xs u-w5of10 u-w10of10--sm" src="/images/slider--right.png" alt="right icon" @click="onNext"/>
              </div>
            </div>
          </div>
        </testimonial-card>
        
        </div>

      </div>
    </div>
  </div>
</template>

<script>

import TestimonialCard from '@/components/strates/TestimonialCard'

export default {
  components: {
    TestimonialCard,
  },
  props: {
    data: {
      type: Array,
      default: () => {return []}
    }
  },

  data() {
    return {
      currentIndex: 0,
      height: 0,
    }
  },

  mounted () {
    this.onResize()
  },

  methods: {
    onResize () {
      this.height = this.$refs.testimonials.reduce((accumulator, el) => accumulator < el.offsetHeight ? el.offsetHeight : accumulator, 0)
    },

    onPrev () {
      this.currentIndex = this.currentIndex === 0 ? this.data.length-1 : this.currentIndex-1
    },

    onNext () {
      this.currentIndex = this.currentIndex === this.data.length - 1 ? 0 : this.currentIndex+1
    }
  }
}
</script>

<style lang="stylus">
@import '~@/styles/settings/mixins/viewport-sizer'
@import '~@/styles/settings/easings'
@import '~@/styles/settings/variables'
@import '~@/styles/settings/mixins/mq'

.testimonials
  max-width 100%

.testimonial
  top 0
  left 0
  width 100% // 10/12
  position absolute
  transition transform 1.2s ease-in-out-quad
  
  &__wrapper
    transition transform 1.2s ease-in-out-quad

  &.is-current
    transform translateX(0) translateZ(0)
  
  &.is-current &__wrapper
    transform translateX(0) translateZ(0)

  &.is-next
    transform translateX(100%) translateZ(0)
  
  &.is-next &__wrapper
    transform translateX(-80%) translateZ(0)

  &.is-prev
    transform translateX(-100%) translateZ(0)
  
  &.is-prev &__wrapper
    transform translateX(80%) translateZ(0)

  &__arrow
    opacity 1
    transform translateZ(0)
    transition opacity .3s linear
    
    &:hover
      opacity .5

  &__quote
    position absolute
    viewportSizer('font-size', 170, 1920)
    viewportSizer('line-height', 50, 1920)
    +mq($from: 'wide')
      font-size 170px
      line-height 170px

    &--left
      top .3em
      right calc(100% + 15px)

    &--right
      bottom 0
      left calc(100% + 15px)
    
</style>